import { addProfileLogEvent } from '../../dashboard/widgets/MyProfile/myProfileSlice'
import { trackEvent } from '../../../helpers/analytics'

const events = {
  stopMarker: {
    object: 'Stop',
    objectId: 'StopMarker',
    action: 'Click',
    actionContext: 'ViewRoutes',
  },
  routeMarker: {
    object: 'Route',
    objectId: 'RouteMarker',
    action: 'Click',
    actionContext: 'ViewRoute',
  },
  vehicleMarker: {
    object: 'Vehicle',
    objectId: 'VehicleMarker',
    action: 'Click',
    actionContext: 'ViewVehicle',
  },
  busFavorite: {
    object: 'BusTab',
    objectId: 'BusFavorite',
    action: 'Click',
    actionContext: 'FavoriteBusRoute',
  },
  stopsFavorite: {
    object: 'StopsTab',
    objectId: 'StopsFavorite',
    action: 'Click',
    actionContext: 'FavoriteBusStop',
  },
  buildingFavorite: {
    object: 'BuildingsTab',
    objectId: 'BuildingFavorite',
    action: 'Click',
    actionContext: 'FavoriteBuilding',
  },
  nearestStopsButton: {
    object: 'BuildingsTab',
    objectId: 'NearestStopsButton',
    action: 'Click',
    actionContext: 'ViewNearestStops',
  },
  directionsMap: {
    object: 'BuildingsTab',
    objectId: 'DirectionsMap',
    action: 'Click',
    actionContext: 'ExternalClick',
  },
  parkingMap: {
    object: 'BuildingsTab',
    objectId: 'ParkingMap',
    action: 'Click',
    actionContext: 'ExternalClick',
  },
  parkingOverlay: {
    object: 'Parking',
    objectId: 'ParkingLotOverlay',
    action: 'Click',
    actionContext: 'ViewParkingLotInfo',
  },
  parkingFilterSelect: {
    object: 'Parking',
    objectId: 'ParkingButtonMenu',
    action: 'Click',
    actionContext: 'ViewParkingFilterOption',
  },
  parkingDirections: {
    object: 'Parking',
    objectId: 'ParkingDirections',
    action: 'Click',
    actionContext: 'ViewParkingDirections',
  },
  parkingChargingStation: {
    object: 'Parking',
    objectId: 'ParkingLotEVCharingStation',
    action: 'Click',
    actionContext: 'ExternalClick',
  },
  parkingTabListItem: {
    object: 'ParkingLotsTab',
    objectId: 'ParkingLotListItem',
    action: 'Click',
    actionContext: 'ViewParkingLotInfo',
  },
  parkingFavorite: {
    object: 'ParkingLotsTab',
    objectId: 'ParkingLotFavorite',
    action: 'Click',
    actionContext: 'FavoriteParkinglot',
  },
  parkingUnfavorite: {
    object: 'ParkingLotsTab',
    objectId: 'ParkingLotFavorite',
    action: 'Click',
    actionContext: 'UnfavoriteParkinglot',
  },
}

export const logMapEvent = (dispatch, event, value) => {
  trackEvent(dispatch, {
    eventName: 'uxp_map_click',
    module: 'Map',
    ...events[event],
    actionContextValue: value,
  })
  if (process.env.REACT_APP_FIREBASE_ON === 'true') {
    dispatch(
      addProfileLogEvent({
        ...events[event],
        module: 'Map',
        actionContextValue: value,
        rcpid: localStorage.getItem('rutgersEduRCPID'),
        timestamp: Date.now(),
      }),
    )
  }
}
